import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.element.addEventListener("form:reinitialize", this.handleReinitialize.bind(this))
        this.element.addEventListener("turbo:submit-start", this.submitStart.bind(this))
        this.element.addEventListener("turbo:submit-end", this.submitEnd.bind(this))
        document.addEventListener("modal:closed", this.handleModalClosed.bind(this))
        this.defaultInnerHtml = null
        this.lastSubmitter = null
    }

    disconnect() {
        this.element.removeEventListener("form:reinitialize", this.handleReinitialize)
        this.element.removeEventListener("turbo:submit-start", this.submitStart)
        this.element.removeEventListener("turbo:submit-end", this.submitEnd)
        document.removeEventListener("modal:closed", this.handleModalClosed)
    }


    submitStart = (e) => {
        e.preventDefault()
        this.defaultInnerHtml = e?.detail?.formSubmission?.submitter?.innerHTML
        this.disableButton(e, true)
        this.shakingModal(true)
    }

    handleModalClosed(e) {
        e.preventDefault()
        if (this.lastSubmitter !== null) {
            this.lastSubmitter.innerHTML = this.defaultInnerHtml;
            this.disableButton(e, false, this.lastSubmitter)
        }

    }

    submitEnd = async (e) => {
        e.preventDefault()

        const submitter = e?.detail?.formSubmission?.submitter
        const rspStatus = e?.detail?.fetchResponse?.response?.status
        const rspHeaders = e?.detail?.fetchResponse?.response?.headers
        const rspBody = e?.detail?.fetchResponse?.response?.body

        const headerEvent = rspHeaders?.get('Event');
        const isJson = rspHeaders?.get('Content-Type').includes('application/json');

        if (headerEvent) {
            const headerEventPayload = JSON.parse(rspHeaders.get('Event-Payload'))
            const event = new CustomEvent(headerEvent, {detail: headerEventPayload})
            document.dispatchEvent(event)
        }

        if (isJson) {
            const body = await new Response(rspBody).json();
            if (body.file) {
                const anchor = document.createElement("a");
                anchor.href = `data:${body.type};base64,` + body.file;
                anchor.target = "_blank";
                anchor.download = body.filename;
                anchor.click();
            }
        }

        if (submitter === undefined) {
            return;
        }

        this.lastSubmitter = null

        if (rspStatus >= 500) {
            submitter.disabled = true
            submitter.innerHTML = 'error'
            submitter.classList.add('disabled')
        } else if (rspStatus === 200) {
            submitter.innerHTML = this.defaultInnerHtml;
            this.disableButton(e, false)
            this.lastSubmitter = submitter
        } else if (rspStatus === 204) {
            this.disableButton(e, true)
        } else if(rspStatus >= 400 && rspStatus < 500) {
            this.shakingModal()
        }
    }

    submit(e) {
        e.stopPropagation()
        this.element.requestSubmit()
    }

    handleReinitialize(e) {
        this.reinitializeForm(e)
    }

    shakingModal(remove = false) {
        const modalContent = this.element.closest('.modal-content')
        if (remove) {
            modalContent?.classList.remove('shake')
        } else {
            modalContent?.classList.add('shake')
        }
    }

    reinitializeForm(e) {
        const input = e.target
        const form = this.formTarget || input.form || input
        const outerTurboFrame = form.closest('turbo-frame[src]')
        const innerTurboFrame = form.closest('turbo-frame')
        const formData = new FormData(form);
        let queryString = new URLSearchParams(formData).toString();
        innerTurboFrame.src = ((outerTurboFrame?.src.split("?")[0] || window.location.href)) + `?${queryString}`
    }
    
    disableButton(e, disabled, sub = null) {
        const submitter = sub || e?.detail?.formSubmission?.submitter
        const disabledText = ICONS['rotate'];

        if (submitter === undefined) {
            return;
        }

        submitter.disabled = disabled
        if (disabled) {
            submitter.classList.add("disabled")
            submitter.form.classList.add("pointer-events-none")
        } else {
            submitter.classList.remove("disabled")
            submitter.form.classList.remove("pointer-events-none")
        }

        if (disabled) {
            submitter.innerHTML = disabledText
        }
    }
}